export default async function ({
  $auth,
  $axios,
  app,
  i18n,
  req,
  redirect,
}) {
  if (i18n.locale !== 'en') {
    const redirect = $auth.$storage.options.redirect

    for (const key in redirect) {
      redirect[key] = '/' + i18n.locale + redirect[key]
    }

    $auth.$storage.options.redirect = redirect
  }

  // Pick up a session started on another subdomain. The Laravel session cookie
  // is shared, but auth-next only fetches the user when its own token cookie
  // exists, which is only set by logging in through this app.
  // Gated on XSRF-TOKEN so guests without an API session don't trigger a request.
  if (
    process.server &&
    !$auth.loggedIn &&
    /(^|;\s*)XSRF-TOKEN=/.test((req && req.headers.cookie) || '')
  ) {
    try {
      const response = await $axios.$get(
        $auth.strategy.options.endpoints.user.url,
      )

      $auth.strategy.token.set(true)
      $auth.setUser(response.data)
    } catch (error) {
      // No active session on the API, stay logged out
    }
  }

  // Revalidate the shared session on focus/reconnect (like SWR), so this site
  // doesn't keep showing a user that was switched or logged out on another
  // subdomain. Reload on change so no page data of the previous user survives.
  // Skipped for guests to avoid a request per focus; a login elsewhere is picked
  // up on the next page load.
  if (process.client) {
    const userUrl = $auth.strategy.options.endpoints.user.url
    let lastCheck = 0

    const revalidate = async () => {
      if (
        !$auth.loggedIn ||
        document.hidden ||
        Date.now() - lastCheck < 5000
      ) {
        return
      }

      lastCheck = Date.now()

      let userId = null

      try {
        const response = await $axios.$get(userUrl)
        userId = (response.data && response.data.id) || null
      } catch (error) {
        // Only a 401 means "no session"; ignore network/server errors
        if (!error.response || error.response.status !== 401) {
          return
        }
      }

      const currentId = ($auth.loggedIn && $auth.user && $auth.user.id) || null

      if (userId !== currentId) {
        $auth.reset()
        window.location.reload()
      }
    }

    window.addEventListener('focus', revalidate)
    window.addEventListener('online', revalidate)
    document.addEventListener('visibilitychange', revalidate)
  }

  $auth.onError(async (error, name, endpoint) => {
    const code = parseInt(error.response && error.response.status)

    if (code === 401) {
      await $auth.logout()

      redirect(app.localePath('/login'))
    }
  })
}
